import axios from 'axios';
import config from '../../config/main';

const createSurvey = async (data) => {
  try {
    const res = await axios({
      method: 'POST',
      url: `${config.apiEndpoint}/surveys`,
      data,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache',
      },
      withCredentials: true,
    });
    return res.data;
  } catch (err) {
    throw new Error(err);
  }
};

const getActiveSurveys = async (data) => {
  try {
    const res = await axios({
      method: 'POST',
      url: `${config.apiEndpoint}/surveys/active`,
      data,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache',
      },
      withCredentials: true,
    });
    return res.data;
  } catch (err) {
    throw new Error(err);
  }
};

const addResponseId = async (surveyNumber, data) => {
  try {
    const res = await axios({
      method: 'POST',
      url: `${config.apiEndpoint}/surveys/${surveyNumber}/responses`,
      data,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache',
      },
      withCredentials: true,
    });
    return res.data;
  } catch (err) {
    throw new Error(err);
  }
};

const getAllSurveys = async () => {
  try {
    const res = await axios({
      method: 'GET',
      url: `${config.apiEndpoint}/surveys`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache',
      },
      withCredentials: true,
    });
    return res.data;
  } catch (err) {
    throw new Error(err);
  }
};

const updateSurveyStatus = async (surveyId, newStatus) => {
  try {
    const res = await axios({
      method: 'PUT',
      url: `${config.apiEndpoint}/surveys/${surveyId}/status`,
      data: { status: newStatus },
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache',
      },
      withCredentials: true,
    });
    return res.data;
  } catch (err) {
    throw new Error(err);
  }
};

const deleteSurvey = async (surveyId) => {
  try {
    const res = await axios({
      method: 'DELETE',
      url: `${config.apiEndpoint}/surveys/${surveyId}`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache',
      },
      withCredentials: true,
    });
    return res.data;
  } catch (err) {
    throw new Error(err);
  }
};

export default {
  createSurvey,
  getActiveSurveys,
  addResponseId,
  getAllSurveys,
  updateSurveyStatus,
  deleteSurvey,
};
